import React from 'react';

export const CustomHeroFormContext = React.createContext({
  customHero: {},
});

export const CustomHeroFormProvider = CustomHeroFormContext.Provider;
